import { render, staticRenderFns } from "./MessagePrompt.vue?vue&type=template&id=66f4461a&scoped=true"
import script from "./MessagePrompt.vue?vue&type=script&lang=js"
export * from "./MessagePrompt.vue?vue&type=script&lang=js"
import style0 from "./MessagePrompt.vue?vue&type=style&index=0&id=66f4461a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f4461a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
